module.exports = __webpack_public_path__ + "static/media/hand-lizard.54f7fb53.svg";